import {SpaceTrSpace, Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import Container = Phaser.GameObjects.Container;
import {ArenaLeague, BattleLog, LeagueDto, SubLeagueDto} from "@/store/arena/types";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import TimeUtils from "@/utils/time-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import ResourceUtils from "@/utils/resource-utils";
import ArenaUtils from "@/utils/arena-utils";

export class ArenaLeaguePanel extends Container {

    private readonly WIDTH: number = 550;
    private readonly FONT_STYLE: string = "italic";

    constructor(scene: Scene, canvas: HTMLCanvasElement, dto: LeagueDto, isEven: boolean) {
        super(scene);

        this.width = this.WIDTH * CU.S;
        this.height = 40 + 25 * CU.S;

        let y = 40 * CU.S;
        let x = 60;

        let x00 = 106;

        let leagueImg = SpriteUtils.addImage(scene, x, y - 1, Keys.ATLAS_LEAGUE, ArenaUtils.getLeagueImg(dto.league), 0.5);

        let leagueName = TextUtils.addTextAdvanced(this.scene, ArenaUtils.getLeagueName(dto.league), x00, y-20,
            ArenaUtils.getLeagueColor(dto.league), 15, this.FONT_STYLE,  500, 'left', 2, Fonts.MYRIADPRO_REGULAR);
        leagueName.setPadding({right:5})
        //тут ещё латинские цифры (под-лиги)

        dto.subLeagues.forEach((subLeague, index) => {

            let positions = TextUtils.addTextAdvanced(this.scene, Tr('daily.arena.reward'),
                x00, y + 5,
                '#ffdfdf', 15, this.FONT_STYLE, 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);
            positions.setPadding({right: 5})
            if (index > 0) positions.visible = false;

            let rewardsMap = new Map<string, number>();
            rewardsMap.set('mithril', subLeague.rewardGems);
            rewardsMap.set('tickets', subLeague.rewardTickets);

            let dailyReward = TextUtils.addTextAdvanced(this.scene, ArenaLeaguePanel.placesRange(subLeague) + ": ", x00, y+30,
                "#ffdfdf", 15, this.FONT_STYLE,  500, 'left', 2, Fonts.MYRIADPRO_REGULAR);

            y += 30;

            let x0 = Math.max( 360, dailyReward.getBottomRight().x!/CU.S + 5);
            rewardsMap.forEach((value, key) => {
                let rewardImage = SpriteUtils.addImage(scene, x0, y , ResourceUtils.findRewardTypeIcon(key), undefined, 0.8).setOrigin(0, 0.5);

                let reward = TextUtils.addTextAdvanced(this.scene, value.toString(),
                    rewardImage.getBottomRight().x!/CU.S, y,
                    '#ffdfdf', 15, this.FONT_STYLE, 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);
                reward.setPadding({right:5})

                if(value == 0){
                    rewardImage.visible = false;
                    reward.visible = false;
                }

                this.add([reward, rewardImage]);
                x0 = reward.getBottomRight().x!/CU.S + 15
            });

            y += 10;
            this.height += 40;

            this.add([ dailyReward, positions]);
        });

        this.add([leagueImg, leagueName]);

    }

    private static placesRange(subLeague: SubLeagueDto) {
        if (subLeague.fromPlace === subLeague.toPlace) {
            return Tr('pl.on') + " " + subLeague.fromPlace + Tr('th.pl');
        }
        return Tr('players.on.positions') + " " + subLeague.fromPlace + "-" + subLeague.toPlace
    }
}
